import { render, staticRenderFns } from "./AlertaCamaraForm.vue?vue&type=template&id=af15fe12&scoped=true&"
import script from "./AlertaCamaraForm.vue?vue&type=script&lang=ts&"
export * from "./AlertaCamaraForm.vue?vue&type=script&lang=ts&"
import style0 from "./AlertaCamaraForm.vue?vue&type=style&index=0&id=af15fe12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af15fe12",
  null
  
)

export default component.exports